<div class="container">
    <label class="date-ranger-picker-input" (click)="showCalendars()" #dateRangeInput>
        <span *ngIf="!showCalendar && labelTxt" class="date-range-text">{{fromDate|date:'d MMM, y'}} - {{toDate|date:'d MMM, y'}}</span>
        <span *ngIf="(showCalendar || !labelTxt) && !changeDate" class="date-range-text">{{labelText}}</span>
        <span *ngIf= "(showCalendar || !labelTxt) && changeDate" class="date-range-text">{{fromDate|date:'d MMM, y'}} - {{toDate|date:'d MMM, y'}}</span>
        <i class='material-icons today'>today</i>
    </label>
    <div *ngIf="showCalendar" class="date-range-picker" #dateRangePickerMenu>
        <div class="calendar-container row">
            <div class="col-md-6 from-calendar">
                <p class="from-date">
                    <span class="content">{{ "sharedComponents.from" | cxTranslate }}</span>
                    <span class="content-bold"> {{ getFormattedDate(fromSelectedDate) }}</span>
                </p>
                <mat-calendar [selected]="fromSelectedDate" [startAt]="fromSelectedDate" (selectedChange)="onFromDateSelect($event)"
                    [minDate]="fromMinDate" [maxDate]="fromMaxDate" #fromCalendar>
                </mat-calendar>
            </div>
            <div class="col-md-6 to-calendar">
                <p class="to-date">
                    <span class="content">{{ "sharedComponents.to" | cxTranslate }}</span>
                    <span class="content-bold"> {{ getFormattedDate(toSelectedDate) }}</span>
                </p>
                <mat-calendar [selected]="toSelectedDate" (selectedChange)="onToDateSelect($event)"
                    [minDate]="fromMinDate" [maxDate]="toMaxDate" #toCalendar>
                </mat-calendar>
            </div>
        </div>
        <div class="action-container">
            <div class="float-left">
                <p class="selected-dates">
                    <span class="content">
                        {{ "sharedComponents.selectTime" | cxTranslate }}
                    </span>
                    <span class="content-bold">
                        {{ getFormattedDate(fromSelectedDate) }}
                    </span>
                    <span class="content to-text">
                        {{ "sharedComponents.to" | cxTranslate }}
                    </span>
                    <span class="content-bold m-0">
                        {{ getFormattedDate(toSelectedDate) }}
                    </span>
                </p>
            </div>
            <div class="float-right">
                <button class="vs-text-btn float-left" (click)="showCalendars()">{{ "sharedComponents.cancel" | cxTranslate }}</button>
                <button class="vs-primary-btn float-left" (click)="onDateRangeSelect()" [disabled]="disableBtn">{{ "sharedComponents.done" | cxTranslate }}</button>
            </div>
        </div>
    </div>
</div>